import { assert, log } from '../app/logger.js';
import { Dialog } from '../controls/dialog.js';
import { window } from '../window.js';

/**
 * Share location link dialog.
 */
class ShareLinkDialog extends Dialog {
  static titleMarkup = `Link to share`;

  static bodyMarkup = `
    <form class='default'>
      <span>Copy link to clipboard and send it to your friends.</span>
      <input>
    </form>
  `;

  static buttons = {
    accept: {
      label: 'Copy & Close',
      image: '/images/app_icons.svg#copy_link',
      default: true,
    },
  };

  static get selectors() {
    return Object.assign({}, super.selectors, {
      Input: 'input',
    });
  }

  static get elements() {
    return {
      inputElement: this.selectors.Input,
    };
  }

  set(loc) {
    assert(loc?.id, `[loc:share-dialog] ShareLinkDialog.set: no loc id`);
    log(
      `[loc:share-dialog] show share link dialog for '${loc.name}':${loc.id}`
    );
    let name = loc.name.replace(/\s/g, '-');
    this.inputElement.value = `${document.location.origin}/loc?${loc.id}&${name}`;
  }

  show() {
    super.show();

    this.inputElement.focus();
    this.inputElement.select();
  }

  accepted() {
    window.navigator.clipboard.writeText(this.inputElement.value);
  }

  static tagName = 'share-link-dialog';
}

ShareLinkDialog.defineCustomElement();

export { ShareLinkDialog };
